import { DF } from "./dateformat.js";
import { CustomConvertError } from "./utils.js";

/**
 * @class Formating
 * @default
 * Форматирование значений
 * */
export default class Formating {
    constructor() {
        this._formating();
        window._df = new DF();
    }

    _formating() {
        String.formatByArray = (...args) => {
            return this._formatInternal(args);
        };

        String.format = (...args) => {
            return this._formatInternal(args);
        };
    }

    _formatInternal(args) {
        let result = "";
        const format = args[0];
        if (!format) {
            return args[1];
        }
        let open = format.indexOf("{");
        let close = format.indexOf("}");
        if (open < 0 && close < 0) {
            // Not found: just replace all
            if (args[1] === undefined) {
                return args[1];
            }
            result = this._getFormatingValue(args[1], format, args[2]);
            return result;
        }
        let iteration = 0;
        for (let i = 0; ;) {
            iteration++;
            // Find the next opening or closing brace
            open = format.indexOf("{", i);
            close = format.indexOf("}", i);
            if (open < 0 && close < 0) {
                // Not found: copy the end of the string and break
                result += format.slice(i);
                break;
            }
            if (close > 0 && (close < open || open < 0)) {
                if (format.charAt(close + 1) !== "}") {
                    return new CustomConvertError(
                        result,
                        "Не найдены парные фигурные скобки",
                        "error"
                    );
                }
                //copy string including closing brace
                result += format.slice(i, close + 1);

                //start next loop from char after closing brace
                i = close + 2;
                continue;
            }
            // Copy the string before the brace
            result += format.slice(i, open);
            i = open + 1;

            // Check for double braces (which display as one and are not arguments)
            if (format.charAt(i) === "{") {
                //we have double brace, so add one to result and got to next loop
                result += "{";
                i++;
                continue;
            }
            if (close < 0) {
                return new CustomConvertError(
                    result,
                    "Не найдена закрывающая фигурная скобка",
                    "error"
                );
            }

            const res = this._getFormatingValue(args[iteration] ?? args.at(-1) ?? "", format.substring(i, close), args[2]);
            if (
                res != null &&
                typeof res === "object" &&
                res.type === "customConvertError"
            ) {
                return res;
            }
            result += res;
            i = close + 1;
        }
        return result;
    }

    _getFormatingValue(value, format, sourceType) {
        if (format === "") {
            return value.toString();
        }
        if (this._isStringFormat(format)) {
            return this._formatText(value.toString(), format);
        } else if (this._isNumberFormat(format)) {
            if (this._isNumeric(Number(value))) {
                return this._formatNumberToString(Number(value), format);
            } else {
                const message = `Не число ${value} не может быть преобразовано в формат |${format}|`;
                return new CustomConvertError(value, message);
            }
        } else {
            const date = new Date(parseInt(Number(value), 10) || value);
            if (!isNaN(date)) {
                return window._df.dateFormat(date, format, ["TIME_OF_DAY", "TIME"].indexOf(sourceType) !== -1);
            }
        }
        return value.toString();
    }

    _formatText(text, format) {
        const len = Number(format.slice(1));
        if (text.length > len) {
            text = text.slice(0, len);
        }
        return text;
    }

    _formatNumberToString(num, format) {
        if (
            !format ||
            format.length === 0 ||
            format === "i" ||
            !isFinite(num)
        ) {
            return num.toString();
        }
        const nf = window._enums.CultureInfo.numberFormat;
        let number = Math.abs(num);
        let precision = -1;
        let pattern;

        if (format.length > 1) {
            precision = parseInt(format.slice(1), 10);
        }
        switch (format.charAt(0)) {
            case "d":
            case "D":
                pattern = "n";
                if (number % 1 === 0) {
                    number =
                        precision === -1
                            ? `${number}`
                            : this._zeroPad(`${number}`, precision, true);
                } else {
                    number = num - (num % 1);
                    const message = `Дробное число ${num} не может быть преобразовано в формат |${format}|`;
                    return new CustomConvertError(number, message);
                }
                if (num < 0) {
                    number = `-${number}`;
                }
                break;
            case "c":
            case "C":
                pattern =
                    num < 0
                        ? nf.currencyNegativePattern
                        : nf.currencyPositivePattern;
                if (precision === -1) {
                    precision = nf.currencyDecimalDigits;
                }
                number = this._numberToString(
                    Math.abs(num),
                    precision,
                    nf.currencyGroupSizes,
                    nf.currencyGroupSeparator,
                    nf.currencyDecimalSeparator
                );
                break;
            case "f":
            case "F":
                pattern = "n";
                if (precision === -1) {
                    precision = nf.numberDecimalDigits;
                }
                number = number.toFixed(precision);
                if (num < 0) {
                    number = `-${number}`;
                }
                break;
            case "e":
            case "E":
                pattern = num < 0 ? nf.numberNegativePattern : "n";
                if (precision === -1) {
                    precision = nf.numberExpDigits;
                }
                number = number.toExponential(precision);
                break;
            case "n":
            case "N":
                pattern = num < 0 ? nf.numberNegativePattern : "n";
                if (precision === -1) {
                    precision = nf.numberDecimalDigits;
                }
                number = this._numberToString(
                    Math.abs(num),
                    precision,
                    nf.numberGroupSizes,
                    nf.numberGroupSeparator,
                    nf.numberDecimalSeparator
                );
                break;
            case "p":
            case "P":
                pattern =
                    num < 0
                        ? nf.percentNegativePattern
                        : nf.percentPositivePattern;
                if (precision === -1) {
                    precision = nf.percentDecimalDigits;
                }
                number = this._numberToString(
                    Math.abs(num) * 100,
                    precision,
                    nf.percentGroupSizes,
                    nf.percentGroupSeparator,
                    nf.percentDecimalSeparator
                );
                break;
            case "x":
            case "X":
                if (number % 1 === 0) {
                    pattern = num < 0 ? nf.numberNegativePattern : "n";
                    const value = this._zeroPad(
                        number.toString(16),
                        precision,
                        true
                    );
                    number =
                        format.charAt(0) === "x"
                            ? value.toLowerCase()
                            : value.toUpperCase();
                } else {
                    number = (num - (num % 1)).toString(16);
                    const message = `Дробное число ${num} не может быть преобразовано в формат |${format}|`;
                    return new CustomConvertError(number, message);
                }
                break;
            default:
                pattern = num < 0 ? nf.numberNegativePattern : "n";
                number = this._numberCustomFormat(format, num, nf);
                break;
        }

        const regex = /[n$\-%]/g;
        let ret = "";
        for (; ;) {
            let index = regex.lastIndex;
            let ar = regex.exec(pattern);
            ret += pattern.slice(index, ar ? ar.index : pattern.length);
            if (!ar) break;
            switch (ar[0]) {
                case "n":
                    ret += number;
                    break;
                case "$":
                    ret += nf.currencySymbol;
                    break;
                case "-":
                    if (/[0-9]/.test(number)) {
                        ret += nf.negativeSign;
                    }
                    break;
                case "%":
                    ret += nf.percentSymbol;
                    break;
            }
        }
        return ret;
    }

    _zeroPad(str, count, left) {
        for (let l = str.length; l < count; l++) {
            str = left ? `0${str}` : `${str}0`;
        }
        return str;
    }

    _numberToString(number, precision, groupSizes, sep, decimalChar) {
        let curSize = groupSizes[0];
        let curGroupIndex = 1;
        const factor = Math.pow(10, precision);
        let rounded = Math.round(number * factor) / factor;
        if (!isFinite(rounded)) {
            rounded = number;
        }
        number = rounded;
        let numberString = number.toString();
        let exponent;
        let split = numberString.split(/e/i);
        numberString = split[0];
        exponent = split.length > 1 ? parseInt(split[1]) : 0;
        split = numberString.split(".");
        numberString = split[0];
        let right = split.length > 1 ? split[1] : "";
        if (exponent > 0) {
            right = this._zeroPad(right, exponent, false);
            numberString += right.slice(0, exponent);
            right = right.substr(exponent);
        } else if (exponent < 0) {
            exponent = -exponent;
            numberString = this._zeroPad(numberString, exponent + 1, true);
            right = numberString.slice(-exponent, numberString.length) + right;
            numberString = numberString.slice(0, -exponent);
        }
        right =
            precision > 0
                ? decimalChar +
                (right.length > precision
                    ? right.slice(0, precision)
                    : this._zeroPad(right, precision, false))
                : "";
        let stringIndex = numberString.length - 1;
        let ret = "";
        while (stringIndex >= 0) {
            if (curSize === 0 || curSize > stringIndex) {
                return ret.length > 0
                    ? numberString.slice(0, stringIndex + 1) + sep + ret + right
                    : numberString.slice(0, stringIndex + 1) + right;
            }
            ret =
                ret.length > 0
                    ? numberString.slice(
                        stringIndex - curSize + 1,
                        stringIndex + 1
                    ) +
                    sep +
                    ret
                    : numberString.slice(
                        stringIndex - curSize + 1,
                        stringIndex + 1
                    );
            stringIndex -= curSize;
            if (curGroupIndex < groupSizes.length) {
                curSize = groupSizes[curGroupIndex];
                curGroupIndex++;
            }
        }
        return numberString.slice(0, stringIndex + 1) + sep + ret + right;
    }

    _numberCustomFormat(format, value, nf) {
        let groupingSeparator,
            groupingIndex,
            decimalSeparator,
            decimalIndex,
            roundFactor,
            i;

        if (!(value instanceof Number)) {
            return value;
        } else {
            groupingSeparator = ",";
            groupingIndex = format.lastIndexOf(groupingSeparator);
            decimalSeparator = ".";
            decimalIndex = format.indexOf(decimalSeparator);
            let integer = "",
                fraction = "",
                minFraction = format
                    .substr(decimalIndex + 1)
                    .replace(/#/g, "").length,
                maxFraction = format.substr(decimalIndex + 1).length,
                powFraction = 10;
            value = Math.abs(value);
            if (decimalIndex != -1) {
                fraction = nf.numberDecimalSeparator;
                if (maxFraction > 0) {
                    roundFactor = 1000;
                    powFraction = Math.pow(powFraction, maxFraction);
                    let tempRound = Math.round(
                        parseInt(
                            value * powFraction * roundFactor -
                            Math.round(value) * powFraction * roundFactor,
                            10
                        ) / roundFactor
                    );
                    let tempFraction = String(
                        tempRound < 0
                            ? Math.round(
                                parseInt(
                                    value * powFraction * roundFactor -
                                    parseInt(value, 10) *
                                    powFraction *
                                    roundFactor,
                                    10
                                ) / roundFactor
                            )
                            : tempRound
                    );
                    let parts = value.toString().split(".");
                    if (typeof parts[1] != "undefined") {
                        for (i = 0; i < maxFraction; i++) {
                            if (
                                parts[1].substr(i, 1) == "0" &&
                                i < maxFraction - 1 &&
                                tempFraction.length != maxFraction
                            ) {
                                tempFraction = "0" + tempFraction;
                            } else {
                                break;
                            }
                        }
                    }
                    for (i = 0; i < maxFraction - fraction.length; i++) {
                        tempFraction += "0";
                    }
                    let symbol,
                        formattedFraction = "";
                    for (i = 0; i < tempFraction.length; i++) {
                        symbol = tempFraction.substr(i, 1);
                        if (
                            i >= minFraction &&
                            symbol == "0" &&
                            /^0*$/.test(tempFraction.substr(i + 1))
                        ) {
                            break;
                        }
                        formattedFraction += symbol;
                    }
                    fraction += formattedFraction;
                }
                if (fraction == nf.numberDecimalSeparator) {
                    fraction = "";
                }
            }
            if (decimalIndex !== 0) {
                integer =
                    fraction != ""
                        ? String(
                            parseInt(
                                Math.round(value * powFraction) / powFraction,
                                10
                            )
                        )
                        : String(Math.round(value));
                let grouping = nf.numberGroupSeparator;
                let groupingSize = 0;
                if (groupingIndex != -1) {
                    groupingSize =
                        decimalIndex != -1
                            ? decimalIndex - groupingIndex
                            : format.length - groupingIndex;
                    groupingSize--;
                }
                if (groupingSize > 0) {
                    let count = 0,
                        formattedInteger = "";
                    i = integer.length;

                    while (i--) {
                        if (count !== 0 && count % groupingSize === 0) {
                            formattedInteger = grouping + formattedInteger;
                        }
                        formattedInteger =
                            integer.substr(i, 1) + formattedInteger;
                        count++;
                    }
                    integer = formattedInteger;
                }
                let maxInteger,
                    maxRegExp = /#|,/g;
                maxInteger =
                    decimalIndex != -1
                        ? format.substr(0, decimalIndex).replace(maxRegExp, "")
                            .length
                        : format.replace(maxRegExp, "").length;
                let tempInteger = integer.length;
                for (i = tempInteger; i < maxInteger; i++) {
                    integer = "0" + integer;
                }
            }
            return integer + fraction;
        }
    }

    _isStringFormat(format) {
        return /^[t].?\d?$/i.test(format);
    }

    _isNumberFormat(format) {
        return /^[edcnfpx][^d]?\d?$/i.test(format);
    }

    _isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
}
